/**
 * Copy del cupo de expedientes activos (issue #568).
 *
 * Vive fuera de `CupoExpedientesNota.tsx` por la regla de Fast Refresh
 * (un archivo que exporta componentes no exporta ademas funciones
 * sueltas) y porque asi lo puede usar tambien `/membresia`, que muestra
 * el cupo sin pintar la nota. Mismo patron que `membresia-vigencia.ts`.
 */

import type { TierName } from "@/lib/api";

export const TIER_LABELS: Record<TierName, string> = {
  esencial: "Esencial",
  pro: "Pro",
};

/**
 * Texto del aviso previo, cuando el plan ya reporta el cupo agotado pero
 * el usuario todavia no intento crear nada.
 *
 * Corto a proposito: la salida de pago es el enlace a `/membresia` que
 * agrega la nota, no una frase mas. Cuando el bloqueo lo reporta el
 * backend (402) NO se usa esta funcion — ahi va el `detail`, que
 * `TierGate` ya curo.
 *
 * `limite` sale de `active_projects.limit`, asi que el numero no puede
 * desfasarse del plan real.
 */
export function textoCupoAgotado(tier: TierName | null, limite: number): string {
  const label = tier ? TIER_LABELS[tier] : null;
  const plan = label ? `Tu plan ${label} permite` : "Tu plan permite";
  return (
    `${plan} ${limite} expedientes activos y ya los tienes todos abiertos. ` +
    "Cierra o rechaza uno para liberar un cupo."
  );
}
